export interface TeamMember {
  id: string;
  name: string;
  role: string;
  areas: string[];
  languages: string[];
  email: string;
  imageUrl?: string;
  initials: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: "sarah-chen",
    name: "Sarah Chen",
    role: "Head of Lettings",
    areas: ["Mayfair", "Belgravia", "Knightsbridge"],
    languages: ["English", "Mandarin"],
    email: "sarah.chen@lettingengine.com",
    initials: "SC",
  },
  {
    id: "james-morrison",
    name: "James Morrison",
    role: "Senior Property Negotiator",
    areas: ["Chelsea", "Kensington", "South Kensington"],
    languages: ["English", "French"],
    email: "james.morrison@lettingengine.com",
    initials: "JM",
  },
  {
    id: "elena-vasquez",
    name: "Elena Vasquez",
    role: "Landlord Account Manager",
    areas: ["Canary Wharf", "Shoreditch", "City of London"],
    languages: ["English", "Spanish"],
    email: "elena.vasquez@lettingengine.com",
    initials: "EV",
  },
  {
    id: "david-okonkwo",
    name: "David Okonkwo",
    role: "Tenant Relations Specialist",
    areas: ["Marylebone", "Fitzrovia", "Soho"],
    languages: ["English", "Yoruba"],
    email: "david.okonkwo@lettingengine.com",
    initials: "DO",
  },
];
